<template>
  <v-dialog content-class="demo-modal-content" class="modal" overlay-opacity=".7" persistent v-model="internal">
    <v-card
      color="black"
      style="width:100%;"
      class="px-3 pt-2 d-flex flex-column demo-modal-card"
    >
      <v-card-actions class="d-flex justify-space-between mx-2 ">
        <h1>{{ $t('requestDemoModal.title') }}</h1>
        <v-btn @click="closeModal" icon><v-icon>mdi-close</v-icon></v-btn>
      </v-card-actions>

      <div class="pa-0 mt-3">
        <v-row no-gutters class="flex-grow-1" >
          <v-col  style="position:relative" class="d-flex flex-grow-1 px-4"  cols="12" md="5" lg="5" sm="12" xs="12">
            <a class="d-flex flex-column customer" href="mailto:support@quartix.io">
                <div class="support-card">
                  <span class="support-eyebrow">{{ $t('requestDemoModal.helpAndSupport') }}</span>
                  <h3 class="support-title">{{ $t('requestDemoModal.alreadyCustomer') }}</h3>
                  <span class="support-link">
                    {{ $t('requestDemoModal.contactSupportTeam') }}
                    <span class="arrow">→</span>
                  </span>
                </div>
            </a>
          </v-col>
          <v-col  class="px-3 pb-3" cols="12" md="7" sm="12" xs="12">
            <the-form :items="items" />     
          </v-col>

        </v-row>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import { useCoreStore } from "@/store/coreStore";
import TheForm from "../forms/TheForm.vue";

export default {
  name: "ImportModal",
  components: {
    TheForm,
  },
  props: {
    value: { type: Boolean, default: false },
  },
  mounted(){
    window.addEventListener('keydown', this.closeEscModal)
  },
  beforeDestroy() {
  window.removeEventListener('keydown', this.closeEscModal)
  },
  data() {
    return {
      items: [{ title: "(21)" }, { title: "(11)" }, { title: "(23)" }],
    };
  },
  computed: {
    internal: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
  },
  methods: {
    closeEscModal(e){
      if(e.code === 'Escape' && this.internal)
      {
        this.closeModal()
      }
    },
    closeModal() {
      const coreStore = useCoreStore();
      this.internal = false;
      coreStore.setRequestDemo(false);
      const path = coreStore.selectedProduct?.path || '/home'
      if(this.$route.path !== path)
      {
        this.$router.push(path);
      }

    },
  },
  watch: {},
};
</script>

<style scoped>

.v-card {
  margin: auto;
}

::v-deep .demo-modal-content {
  width: min(92vw, 900px);
  max-width: 92vw;
  scrollbar-width: none;
}

.demo-modal-card {
  height: 100%;
  overflow: hidden;
}

.demo-modal-card.pa-3 {
  padding: clamp(0.15rem, 1.8dvh, 1rem) !important;
}

.demo-modal-card .mx-2 {
  margin-left: clamp(0.1rem, 1.2dvh, 0.5rem) !important;
  margin-right: clamp(0.1rem, 1.2dvh, 0.5rem) !important;
}

.demo-modal-card h1 {
  font-size: clamp(0.75rem, 3.2dvh, 1.5rem);
}

.demo-modal-card .mt-6 {
  margin-top: clamp(0.1rem, 2dvh, 1.5rem) !important;
}

.demo-modal-card .pb-5 {
  padding-bottom: clamp(0.1rem, 1.2dvh, 1.5rem) !important;
}

.file-name {
  border: 1px solid white;
  padding: 0.3rem 1rem;
  width: 60%;
  border-radius: 3px;
}
.upload-files {
  cursor: pointer;
  border: 3px dashed white;
  border-radius: 10px;
  width: 100%;
  padding-top: 3rem;
  padding-bottom: 4rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}
.customer{
  flex-grow:1;
  position:relative;
  cursor: pointer;
  background: #111111;
  border-radius: 16px;
  align-self: flex-start;
}
a{
  text-decoration: none;
}

.customer:hover{
  transition: all .3s ease;
    background: #090909;
}

.customer:hover .support-link{
    color: #ffbf00;
    text-decoration: none;
}

.support-card {
  padding: clamp(0.4rem, 3.5dvh, 28px) clamp(0.6rem, 3vw, 32px);
  padding-left: clamp(0.6rem, 3vw, 2rem);
  display: flex;
  flex-direction: column;
  gap: clamp(0.15rem, 1.5dvh, 14px);
}

.support-eyebrow {
  font-size: 13px;
  font-weight: 600;
  color: #a3a3a3; 
}

/* Title */
.support-title {
  font-size: clamp(15px, 2vw, 20px);
  font-weight: 700;
  color: #ffffff;
  margin: 0;
  margin-bottom: clamp(0.15rem, 1.5dvh, 1rem);
}

/* Link */
.support-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 500;
  color: #b8b8b8; 
  text-decoration: none;
}

.support-link:hover {
  text-decoration: underline;
}

/* Arrow */
.support-link .arrow {
  font-size: 18px;
  line-height: 1;
}
.upload-files h5 {
  font-weight: 400 !important;
}

.is-active {
  background: rgba(38, 194, 129, 0.4) !important;
  border: 1px solid var(--success) !important;
  font-weight: 700;
  color: var(--success) !important;
}
.agg-label {
  background: rgba(255, 138, 61, 0.4) !important;
  border: 1px solid var(--main-color) !important;
  color: var(--main-color) !important;
  font-weight: 700 !important;
}
</style>
